import { useRef, useState } from 'react'
import { Icon } from './Icon'
import { BrandIfood, Brand99 } from './Brands'
import { useParallax } from '../hooks/useParallax'
import { linkWhatsApp } from '../config'

const MINI = [
  { icone: 'chat', linhas: ['Atendimento', 'consultivo'] },
  { icone: 'gear', linhas: ['Soluções sob', 'medida'] },
  { icone: 'chart', linhas: ['Acompanhamento', 'contínuo'] },
  { icone: 'target', linhas: ['Foco em', 'resultados reais'] },
]

export function Hero() {
  const cena = useRef<HTMLDivElement>(null)
  useParallax(cena)

  // A foto e o fundo da secao inteira. O desenho em CSS (.stage) e reserva:
  // so aparece se a foto faltar — por isso `sem-foto` em vez de mostrar os
  // dois e deixar o desenho piscando enquanto a imagem baixa.
  const [foto, setFoto] = useState<'carregando' | 'ok' | 'falhou'>('carregando')
  const estado = foto === 'ok' ? ' has-photo' : foto === 'falhou' ? ' sem-foto' : ''

  return (
    <section className={`hero${estado}`} id="inicio">
      <div className="hero__bg" aria-hidden="true">
        <div className="hero__media">
          <img
            className="hero__photo"
            src="/assets/img/hero.webp"
            alt=""
            onLoad={() => setFoto('ok')}
            onError={() => setFoto('falhou')}
          />
        </div>
        <span className="shard shard--tl" />
        <span className="shard shard--bl" />
        <span className="shard shard--tr" />
        <span className="grain" />
      </div>

      <div className="shell hero__inner">
        <div className="hero__copy">
          <p className="eyebrow" data-reveal="up"><i />Seu restaurante em outro nível</p>
          <h1 className="hero__title">
            <span className="line" data-reveal="mask">Mais visibilidade.</span>
            <span className="line" data-reveal="mask" data-delay="80">Mais pedidos.</span>
            <span className="line accent" data-reveal="mask" data-delay="160">Mais crescimento.</span>
          </h1>
          <p className="hero__lead" data-reveal="up" data-delay="260">
            Estruturação, gestão e tecnologia para o seu restaurante
            vender mais no iFood, 99 Food e no seu próprio canal.
          </p>
          <div className="hero__actions" data-reveal="up" data-delay="340">
            <a href={linkWhatsApp()} className="btn btn--primary" data-magnetic>
              <Icon name="wa" className="ico" /> Quero conversar agora
            </a>
            <a href="#planos" className="btn btn--outline" data-magnetic>
              Conheça nossos planos <span className="arw">&rarr;</span>
            </a>
          </div>

          <ul className="hero__mini" data-reveal="up" data-delay="420">
            {MINI.map((item) => (
              <li key={item.linhas.join(' ')}>
                <span className="hero__mini-ico"><Icon name={item.icone} /></span>
                {item.linhas[0]}<br />{item.linhas[1]}
              </li>
            ))}
          </ul>
        </div>

        <div className="hero__visual" ref={cena} data-parallax-scene>
          <div className="stage">
            <div className="phone phone--ifood float">
              <div className="phone__screen phone__screen--ifood has-logo"><BrandIfood /></div>
            </div>
            <div className="phone phone--99 float float--slow">
              <div className="phone__screen phone__screen--99 has-logo"><Brand99 /></div>
            </div>
            <span className="stage__glow" aria-hidden="true" />
          </div>
        </div>
      </div>
    </section>
  )
}
